// 获取所有的可用面板
const resultComps = {}
let requireEntry = require.context(
    './', // 在当前目录下查找
    false, // 不遍历子文件夹
    /\.vue$/ // 正则匹配 以 .vue结尾的文件
)
requireEntry.keys().forEach(fileName => {
    let comp = requireEntry(fileName)
    resultComps[fileName.replace(/^\.\/(.*)\.\w+$/, '$1')] = comp.default
})
export default resultComps